import _Vue, { PluginFunction } from 'vue';

export interface BrowserInfo {
	name: string;
	version?: number;
}

export const BrowserDetect: PluginFunction<void> = (Vue: typeof _Vue) => {
	Vue.prototype.$detectBrowser = function(): BrowserInfo {
		let temp;
		let name = '?';
		let version;

		const userAgent = window.navigator.userAgent || navigator.userAgent;
		let matches =
			userAgent.match(
				/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i,
			) || [];
		if (/trident/i.test(matches[1])) {
			temp = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
			name = 'IE';
			if (temp[1]) {
				version = Number(temp[1]);
			}
			return { name, version };
		}

		if (matches[1] === 'Chrome') {
			temp = userAgent.match(/\b(OPR|Edge?)\/(\d+)/);
			if (temp != null) {
				name = temp[1].replace('OPR', 'Opera').replace('Edg ', 'Edge ');
				if (temp[2]) {
					version = Number(temp[2]);
				}
				return { name, version };
			}
		}

		matches = matches[2]
			? [matches[1], matches[2]]
			: [navigator.appName, navigator.appVersion, '-?'];
		if ((temp = userAgent.match(/version\/(\d+)/i)) != null) {
			matches.splice(1, 1, temp[1]);
		}

		return {
			name: matches[0],
			version: Number(matches[1]),
		};
	};
};
